import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isChannelAvailable, createMarkup } from '../helpers';
import { setEmailMeBackProductID } from '../../../../appState/ducks/listingPageProducts';


class ProductChannelsAvailability extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fadeOutBackground: false
    };
    this.showEmailWhenBack = this.showEmailWhenBack.bind(this);
  }

  /**
   * When placeSpecificAvailability becomes present in props, highlight channelsAvailability
   * in CSS, applied using fadeOutBackground state prop.
   * @param nextProps
   */
  componentWillReceiveProps(nextProps) {
    if (nextProps.channelsAvailability.placeSpecificAvailability &&
      !this.props.channelsAvailability.placeSpecificAvailability) {
      this.setState({
        fadeOutBackground: true
      });
      this.fadeOutTimeoutID = setTimeout(
        () => this.setState({ fadeOutBackground: false }),
        7000
      );
    }
  }

  componentWillUnmount() {
    if (this.fadeOutTimeoutID) {
      clearTimeout(this.fadeOutTimeoutID);
    }
  }

  getIconClassName(channelType) {
    if (isChannelAvailable(channelType)) {
      return 'dcg-icon-tick';
    }
    return 'dcg-icon-cross';
  }

  /**
   * If at least some delivery channel is available (default or place specific), return true.
   * @returns {boolean}
   */
  hasProductAvailableChannel() {
    if (this.props.channelsAvailability.placeSpecificAvailability) {
      const placeSpecific = this.props.channelsAvailability.placeSpecificAvailability;

      if ((placeSpecific.delivery && isChannelAvailable(placeSpecific.delivery.type)) ||
        (placeSpecific.inStore && isChannelAvailable(placeSpecific.inStore.type))) {
        return true;
      }
    }

    if (this.props.channelsAvailability.defaultAvailability) {
      const defaultAvailability = this.props.channelsAvailability.defaultAvailability;

      if ((defaultAvailability.delivery && isChannelAvailable(defaultAvailability.delivery.type)) ||
        (defaultAvailability.inStore && isChannelAvailable(defaultAvailability.inStore.type))) {
        return true;
      }
    }

    return false;
  }

  hasProductSpecificAvailability() {
    return this.props.channelsAvailability.placeSpecificAvailability &&
      (this.props.channelsAvailability.placeSpecificAvailability.inStore ||
        this.props.channelsAvailability.placeSpecificAvailability.delivery
      );
  }

  showEmailWhenBack(e) {
    e.preventDefault();
    this.props.setEmailMeBackProductID(this.props.id);
  }

  renderDownload() {
    // According to old code, if product is download and has loaded specificAvailability,
    // change icon from download to tick.
    const iconClassName = this.hasProductSpecificAvailability()
      ? 'dcg-icon-tick' : 'dcg-icon-download';

    return (
      <ul className="simple prd-channels" data-product="availability">
        <li className="available" data-availability="downloadAvailable">
          <i className={iconClassName} />
          {this.props.translations.downloadProductTranslation}
        </li>
      </ul>
    );
  }

  renderEmailMeBack() {
    let emailMeBackClasses = 'simple prd-channels';

    emailMeBackClasses += this.props.isEmailMeBackHidden ? ' hidden' : '';

    return (
      <ul className={emailMeBackClasses} data-product="availability">
        <li className="nostock">
          <i className="dcg-icon-cross" />
          {this.props.translations.emailMeBackFirstLineTranslation}
        </li>
        <li className="nostock">
          <span
            data-href="#email-when-back-desktop"
            data-fupid={this.props.id}
            className="email-when-back"
            onClick={this.showEmailWhenBack}
          >
            <i className="dcg-icon-mail" />
            <span>{this.props.translations.emailMeBackLinkTranslation}</span>
          </span>
        </li>
      </ul>
    );
  }

  renderLocationLabel() {
    // If there is no placeSpecificAvailability, there is no label to render.
    // Default availability does not have label.
    if (!this.props.placeNameTranslation) {
      return <noscript />;
    }

    const classNames = ['location'];

    if (this.hasProductAvailableChannel()) {
      classNames.push('available');
    } else {
      classNames.push('unavailable');
    }

    return (
      <div className={classNames.join(' ')}>
        {this.props.translations.forDeliveryPlaceTranslation}&nbsp;
        <span>
          {this.props.placeNameTranslation}
        </span>
      </div>
    );
  }

  renderLocationAvailabilities() {
    // if placeSpecificAvailability is present, use that, has higher priority.
    const channel = this.hasProductSpecificAvailability()
      ? this.props.channelsAvailability.placeSpecificAvailability
      : this.props.channelsAvailability.defaultAvailability;

    if (channel.canBeDownloaded) {
      return this.renderDownload();
    } else if (channel.showEmailMeBack) {
      return this.renderEmailMeBack();
    }

    return (
      <ul className="simple prd-channels" data-product="availability">
        {[channel.delivery, channel.inStore].filter(el => el)
          .map((availabilityChannel, i) => (
            <li
              key={i}
              className={isChannelAvailable(availabilityChannel.type) ? 'available' : 'unavailable'}
            >
              <i className={this.getIconClassName(availabilityChannel.type)} />
              <span dangerouslySetInnerHTML={createMarkup(availabilityChannel.label)} />
            </li>
        ))}
      </ul>
    );
  }

  render() {
    const classNames = ['channels-availability'];

    if (this.props.pendingLocationRequest === true) {
      classNames.push('pending-request');
    }

    if (this.state.fadeOutBackground === true) {
      classNames.push('bkg-fadeout');
    }

    return (
      <div
        className={classNames.join(' ')}
        style={this.props.channelsAvailabilityHeight
          ? { height: this.props.channelsAvailabilityHeight } : undefined}
      >
        {this.props.pendingLocationRequest === false &&
        <Fragment>
          {this.renderLocationLabel()}
          {this.renderLocationAvailabilities()}
        </Fragment>
        }
      </div>);
  }
}

ProductChannelsAvailability.propTypes = {
  channelsAvailability: PropTypes.shape({
    placeSpecificAvailability: PropTypes.shape({
      delivery: PropTypes.shape({}),
      inStore: PropTypes.shape({})
    }),
    defaultAvailability: PropTypes.shape({})
  }).isRequired,
  pendingLocationRequest: PropTypes.bool.isRequired,
  setEmailMeBackProductID: PropTypes.func,
  isEmailMeBackHidden: PropTypes.bool,
  id: PropTypes.string.isRequired,
  translations: PropTypes.shape({
    forDeliveryPlaceTranslation: PropTypes.string.isRequired,
    downloadProductTranslation: PropTypes.string.isRequired,
    emailMeBackFirstLineTranslation: PropTypes.string.isRequired,
    emailMeBackLinkTranslation: PropTypes.string.isRequired
  }).isRequired,
  placeNameTranslation: PropTypes.string,
  // for dynamic sizing if used in Grid
  channelsAvailabilityHeight: PropTypes.number
};

ProductChannelsAvailability.defaultProps = {
  placeNameTranslation: null,
  setEmailMeBackProductID: () => {},
  isEmailMeBackHidden: false,
  channelsAvailabilityHeight: undefined
};


function mapStateToProps(state, ownProps) {
  const placeNameTranslation = state.listingPage.locationSearch.currentFoundLocation &&
    state.listingPage.locationSearch.currentFoundLocation.location;

  return {
    pendingLocationRequest: state.listingPage.pageSetup.xhrStatus.pendingLocationRequest,
    placeNameTranslation: placeNameTranslation,
    isEmailMeBackHidden: state.listingPage.products.emailWhenBackFormProductID === ownProps.id
  };
}

export default connect(mapStateToProps, { setEmailMeBackProductID })(ProductChannelsAvailability);
